import { render, staticRenderFns } from "./AssignmentPage.vue?vue&type=template&id=8fbe6bee&scoped=true&"
import script from "./AssignmentPage.vue?vue&type=script&lang=js&"
export * from "./AssignmentPage.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPage.vue?vue&type=style&index=0&id=8fbe6bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbe6bee",
  null
  
)

export default component.exports